/*
 * @Author: 17388316638 lemon1234..
 * @Date: 2022-09-09 10:04:53
 * @LastEditors: 17388316638 lemon1234..
 * @LastEditTime: 2022-09-09 15:24:40
 * @FilePath: \qcsdjyBigdataUI\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/css/common.css";
import "@/assets/css/animate.css";
import * as echarts from "echarts";
import { flylineChart } from "@jiaminghi/data-view";
import "@/tool/echarts-auto-tooltip";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
Vue.use(flylineChart);
Vue.prototype.$echarts = echarts;
import "echarts-liquidfill";

import { useStartActions } from "@/tool/useStartActions";
import { use } from "echarts/core";

import ECharts from "vue-echarts";
import {
	BarChart,
	LineChart,
	PictorialBarChart,
	CustomChart,
} from "echarts/charts";
import {
	GridComponent,
	TooltipComponent,
	TitleComponent,
	LegendComponent,
} from "echarts/components";
use([
	GridComponent,
	TooltipComponent,
	TitleComponent,
	LegendComponent,
	BarChart,
	LineChart,
	PictorialBarChart,
	CustomChart,
]);
Vue.mixin({
	methods: {
		useStartActions,
	},
});
Vue.component("v-chart", ECharts);
const initWindow = () => {
	document.body.style.transform = `scale(${
		document.documentElement.offsetWidth / 1920
	}, ${document.documentElement.offsetHeight / 1080})`;
};
const onDebounce = (fn, delay = 200) => {
	var timer = null;
	return function () {
		clearTimeout(timer);
		timer = setTimeout(function () {
			fn.apply(this);
		}, delay);
	};
};
initWindow();
window.onresize = onDebounce(initWindow);
Vue.config.productionTip = false;
const cancelDefaltList = ["/qdBigData"];
Vue.prototype.$currentHttpRequestList = new Map();
Vue.prototype.$cancelRequest = function (cancelkey) {
	if (cancelkey) {
		if (cancelkey.indexOf("/**") > -1) {
			Vue.prototype.$currentHttpRequestList.forEach((item, key) => {
				key.indexOf(cancelkey.split("/**")[0]) > -1 &&
					item("Operation canceled by the user.");
			});
		} else {
			Vue.prototype.$currentHttpRequestList.get(cancelkey) &&
				Vue.prototype.$currentHttpRequestList.get(cancelkey)(
					"Operation canceled by the user."
				);
		}
	} else {
		cancelDefaltList.forEach((eachWite) => {
			Vue.prototype.$currentHttpRequestList.forEach((item, key) => {
				key.indexOf(eachWite.split("/**")[0]) > -1 &&
					item("Operation canceled by the user.");
			});
		});
	}
};
new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
